import { useEffect, useState } from 'react'
import ParseAPI from '@api/ParseAPI'

const log = new window.Logger('useFetchDocument')

export const useFetchDocument = (documentId, onSuccess, onFailure) => {
    
    const [loading, setLoading] = useState(false)
    
    useEffect(() => {
        
        if (!documentId) return
        
        const fn = async () => {
            
            setLoading(true)
            
            try {
                
                const res = await ParseAPI.get(`/document/${documentId}`)
                
                log.v('Fetched document', res.data)
                onSuccess(res.data)
                
            } catch (e) {
                
                // @todo show error
                log.e(e)
                
                // Document doesn't exist
                if (e.response.status === 404)
                    onFailure(e)
                
            }
            
            setLoading(false)
            
        }
        
        fn()
        
    }, [documentId])
    
    return loading
    
}
